/**
 * Platform Meta Pixel for stylon.co — acquisition/retargeting tracking for the marketing
 * site itself (distinct from the per-salon pixel on the web-store). Env-gated via
 * REACT_APP_META_PIXEL_ID; when unset, this module is a complete no-op (no script
 * injected, window.fbq left undefined) so shipping this code is safe with no live ID.
 *
 * Injection idiom copied verbatim from stylon-web-store-page's metaPixel.js so both
 * apps share one battle-tested loader.
 */

let injectedId = null;

export function initMetaPixel(pixelId) {
  if (!pixelId || typeof window === 'undefined' || injectedId === pixelId) return;
  try {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', String(pixelId));
    window.fbq('track', 'PageView');
    injectedId = pixelId;
  } catch (_) {
    /* never throw from instrumentation */
  }
}

/** Fire a standard Meta Pixel event. Best-effort, no-op if the pixel isn't loaded. */
export function pixelTrack(metaEvent, params) {
  if (typeof window === 'undefined' || !window.fbq) return;
  try {
    window.fbq('track', metaEvent, params || undefined);
  } catch (_) {
    /* never throw from instrumentation */
  }
}

/** Fire a custom Meta Pixel event. Best-effort, no-op if the pixel isn't loaded. */
export function pixelTrackCustom(name, params) {
  if (typeof window === 'undefined' || !window.fbq) return;
  try {
    window.fbq('trackCustom', name, params || undefined);
  } catch (_) {
    /* never throw from instrumentation */
  }
}

/**
 * Pure mapper: our internal GA4-style funnel event name → the corresponding Meta
 * standard/custom event. Fixed mapping (see plan Global Constraints) — anything not
 * listed here is GA-only and must NOT be sent to the pixel.
 */
export function mapFunnelEventToMeta(gaEvent) {
  switch (gaEvent) {
    case 'page_view':
      return { type: 'track', name: 'PageView' };
    case 'lead':
      return { type: 'track', name: 'Lead' };
    case 'begin_checkout':
      return { type: 'track', name: 'InitiateCheckout' };
    case 'sign_up':
      return { type: 'track', name: 'CompleteRegistration' };
    case 'purchase':
      return { type: 'track', name: 'Purchase' };
    case 'start_onboarding_click':
      return { type: 'trackCustom', name: 'StartOnboarding' };
    case 'begin_onboarding':
      return { type: 'trackCustom', name: 'BeginOnboarding' };
    default:
      return { type: null, name: null };
  }
}
